let LocalAreaComponent = {
    container: {},
    map: {},
    markers: [],
    infobox: {},
    mainPushpin: {},
    zoomLevel: 50,
    init: function(container, bingAvailable) {
        this.container = container;
        if (bingAvailable) {
            localAreaData.init().then( () => {
                let areaData = localAreaData.get();

                //get main store info for map
                const latitude = areaData.development.latitude;
                const longitude = areaData.development.longitude;
                const mainMarker = areaData.development.icon;
                this.zoomLevel = areaData.configuration.zoomLevel;
                const marketingLatitude = areaData.development.marketingLatitude;
                const marketingLongitude = areaData.development.marketingLongitude;
                const marketingIcon = areaData.development.marketingIcon;

                //init bing map with main dev coordinates
                this.map = new Microsoft.Maps.Map(document.getElementById('map'), {
                    center: new Microsoft.Maps.Location(latitude, longitude),
                    disableScrollWheelZoom: true,
                    showMapTypeSelector: false,
                    zoom: this.zoomLevel,
                });


                //add pushpin on map for the main location
                this.mainPushpin = new Microsoft.Maps.Pushpin(new Microsoft.Maps.Location(
                    latitude, 
                    longitude), {
                        icon: mainMarker,
                    }
                );
                this.map.entities.push(this.mainPushpin);

                //add pushpin on map for the marketing location
                if (marketingLatitude && marketingLongitude && marketingIcon) {
                    let marketingPushpin = new Microsoft.Maps.Pushpin(
                        new Microsoft.Maps.Location(marketingLatitude, marketingLongitude),
                        {
                            icon: marketingIcon,
                        }
                    );
                    this.map.entities.push(marketingPushpin);
                }

                // Create an infobox and assign it to the map instance.
                this.infobox = new Microsoft.Maps.Infobox(this.map.getCenter(), {
                    visible: false,
                });
                this.infobox.setMap(this.map);

                if (areaData.categories.length > 0) {
                    this.displayPointsOfInterest(areaData.categories);
                }
                this.setZoomToShowAll();
            });
        }
    },
    displayPointsOfInterest: function(categories) {

        categories.forEach((category) => {
            if (category.subcategories.length > 0) {
                category.subcategories.forEach((subcategory) => {
                    subcategory.places.forEach((place) => {
                        this.addMarker(place, subcategory, subcategory.subcatId);
                    });
                });
            }
        });

    },
    setZoomToShowAll: function() {
        // create array of locations to be displayed on map and add Development marker
        let locs = [this.mainPushpin.getLocation()];

        // loop over markers, toggling visibility of type selected and adding location of all displayed markers to locations
        this.markers.forEach((markItem) => {
            locs.push(markItem.marker.getLocation());
        });

        //if the only marker is the Development then centre on that and revert to original zoom
        if ( locs.length === 1) {
            this.map.setView({
                center: locs[0],
                zoom: this.zoomLevel,
            });
        } else {
            // else set bounds to show all markers
            this.map.setView({
                bounds: Microsoft.Maps.LocationRect.fromLocations(locs),
                padding: 50,
            });
        }       
    },
    addMarker: function(place, subCategory, subCategoryId ) {
        let pushpin = new Microsoft.Maps.Pushpin(new Microsoft.Maps.Location(place.latitude, place.longitude), {
            icon: subCategory.icon,
            visible: true,
            roundClickableArea: true,
        });
        pushpin.metadata = {
            title: place.title,
            description: place.address + '<br>' + place.postCode,
        };
        Microsoft.Maps.Events.addHandler(pushpin, 'click', this.pushpinClicked);
        this.map.entities.push(pushpin);
        this.markers.push({
            marker: pushpin,
            type: subCategory.title,
            subCatId: subCategoryId,
        });
    
    },
    // pushpin clicked display the infobox - "this" scope is handler,  
    pushpinClicked: function(e) {
        LocalAreaComponent.map.setView({ center: e.target.getLocation() });
        LocalAreaComponent.infobox.setOptions({
            location: e.target.getLocation(),
            title: e.target.metadata.title,
            description: e.target.metadata.description,
            offset: new Microsoft.Maps.Point(0, 48),
            visible: true,
        });
    }
};